"use strict";

exports.__esModule = true;
exports.default = minTranslate;

function minTranslate() {
  return -this.snapGrid[0];
}


//////////////////
// WEBPACK FOOTER
// ./~/swiper/cjs/components/core/translate/minTranslate.js
// module id = 61
// module chunks = 0